import { CLOSED, OFFER_LATER, ON_OFFER } from "../../../types/offerStates";
import { isClosingTime } from "../isClosingTime";
import { getDayString, getTimeFromString, minutesToString } from "./utils";

export const calculateClosingTimes = (
  restaurants: RestaurantFromAPI[],
  date: Date
): Restaurant[] =>
  restaurants
    .map(r => ({
      ...r,
      closingTimes: getClosingTimes(r.closingTimes)
    }))
    .map((r: RestaurantCurrent) => ({
      ...r,
      ...getCurrentDiscountStatus(r.closingTimes, date)
    }));

export const getClosingTimes = (
  closingTimes: ClosingTimes
): ClosingTimesCurrent => {
  return Object.keys(closingTimes).reduce((result: any, day) => {
    if (isClosingTime(closingTimes[day])) {
      try {
        result[day] = getClosingTime(closingTimes[day]);
      } catch (e) {
        console.log(closingTimes[day]);
      }
    }
    return result;
  }, {});
};

export const getClosingTime = (
  closingTime: ClosingTime
): ClosingTimeCurrent => {
  const closingTimeObject = getTimeFromString(closingTime.closingTime);
  const duration = getTimeFromString(closingTime.discountPeriod);
  const startDiscount = new Date();
  startDiscount.setHours(closingTimeObject.getHours() - duration.getHours());
  startDiscount.setMinutes(
    closingTimeObject.getMinutes() - duration.getMinutes()
  );
  startDiscount.setSeconds(0);
  return {
    ...closingTime,
    discountStartingTime: `${
      startDiscount.getHours() < 10
        ? "0" + startDiscount.getHours()
        : startDiscount.getHours()
    }:${minutesToString(startDiscount.getMinutes())}`
  };
};

export const getCurrentDiscountStatus = (
  closingTimes: ClosingTimes,
  currentDate: Date
): {
  status: OfferStatus;
  startingTimeString: string;
  discountString: string;
} => {
  const dayOfWeek = getDayString(new Date(currentDate).getDay());
  const closingTimeObj = closingTimes[dayOfWeek];
  if (!isClosingTime(closingTimeObj)) {
    return {
      status: CLOSED,
      startingTimeString: "",
      discountString: "Restaurant closed today."
    };
  }
  const { discountStartingTime, discountPercent, closingTime } = closingTimeObj;
  switch (
    getStatus(
      currentDate,
      getTimeFromString(discountStartingTime),
      getTimeFromString(closingTime)
    )
  ) {
    case ON_OFFER:
      return {
        status: ON_OFFER,
        startingTimeString: discountStartingTime,
        discountString: `${discountPercent}% off from ${discountStartingTime} to ${closingTime}`
      };
    case OFFER_LATER:
      return {
        status: OFFER_LATER,
        startingTimeString: discountStartingTime,
        discountString: `${discountPercent}% off starts at ${discountStartingTime}`
      };
    default:
      return {
        status: CLOSED,
        startingTimeString: discountStartingTime,
        discountString: `${discountPercent}% ended at ${closingTime}`
      };
  }
};

export const minutesOfDay = (date: Date) => {
  return date.getMinutes() + date.getHours() * 60;
};

export const sameDay = (d1: Date, d2: Date) => {
  return (
    d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate()
  );
};

export const getStatus = (
  currentDate: Date,
  startDiscount: Date,
  closingTime: Date
): OfferStatus => {
  if (
    sameDay(currentDate, startDiscount) &&
    sameDay(currentDate, closingTime)
  ) {
    const curr = minutesOfDay(currentDate);
    const start = minutesOfDay(startDiscount);
    return curr >= start && curr <= minutesOfDay(closingTime)
      ? ON_OFFER
      : curr < start
      ? OFFER_LATER
      : CLOSED;
  } else {
    return currentDate >= startDiscount && currentDate <= closingTime
      ? ON_OFFER
      : currentDate < startDiscount
      ? OFFER_LATER
      : CLOSED;
  }
};
